import React, {useState} from 'react'
import {Button} from "primereact/button";
import {Checkbox} from "primereact/checkbox";
import DHDialog from "../../general/DHDialog";
import DHButtonClose from "../../general/DHButtonClose";

export default function KalenderNewEventDialog({tournamentId, onSave, onClose}) {

    let [nurAktuellesTurnier, setNurAktuellesTurnier] = useState(false);

    return <DHDialog onClose={() => onClose()} title="Neuer Kalendereintrag" show={true}
                     comp={<>
        <div style={{textAlign:"left"}}>
            {tournamentId === undefined &&
                <div style={{marginTop:10, marginBottom: 10}}>
                    Dein Termin wird in allen Turnieren/Ligen sichtbar sein und kann überall angenommen werden.
                    Sofern du einen Termin ausschliesslich in einem Turnier/ einer Liga anbieten möchtest, setze diesen Kalendereintrag direkt im Turnier.
                </div>
            }
            {tournamentId !== undefined && <>
                <div style={{marginBottom:10, fontWeight:"bold", color:"red"}}>ACHTUNG!!!</div>
                <div style={{marginBottom:5 }}>Sobald du den Termin zum Turnier/Liga speicherst, wird dieser anderen nur in diesem Turnier/dieser Liga angezeigt.</div>
                <div style={{marginBottom:5 }}>Du bist selbst dafür verantwortlich, dass du in unterschiedlichen Turnieren/Ligen keine Terminüberschneidungen einstellst.</div>
                <div style={{marginBottom:20 }}>Eine Gesamtübersicht deiner Termine findest du auf dem Dashboard unter dem Punkt Kalender.</div>
                <div style={{marginTop:20}}>
                    <span style={{marginRight:10}}>nur am aktuellen Turnier/<br/>der aktuellen Liga anzeigen:</span><Checkbox checked={nurAktuellesTurnier}
                              onChange={() => setNurAktuellesTurnier(!nurAktuellesTurnier)}/>
                </div>
            </>
            }
            <div style={{marginTop:20}}>
                <Button label="Speichern"
                        type="button" onClick={() => onSave(nurAktuellesTurnier)} style={{marginRight:5}}/>
                <DHButtonClose onClick={() => onClose()}/>
            </div>
        </div>
    </>}/>
}
